export const DEFAULT_TODOS = {
  // Onboarding Steps
  START: false,
  RETURN_REASONS: false,
  RETURN_WINDOW: false,
  REFUND_METHODS: false,
  EXCHANGES: false,
  SHIPPING: false,
  FEES: false,
  COMPLETED: false,

  // Other Tasks
  BRANDED_THEME: false,
  EMAIL_TEMPLATES: false,
  EXCHANGES_CONFIG: false
};

export const STEP_ID = Object.freeze({
  START: 'START',
  ACCEPTANCE: 'ACCEPTANCE',
  RETURN_WINDOW: 'RETURN_WINDOW',
  EXCHANGES: 'EXCHANGES',
  SHIPPING: 'SHIPPING',
  FEES: 'FEES',
  COMPLETED: 'COMPLETED'
});

/** @type {import("utils/types").StepperStep} */
export const RETURN_MODE_STEP = {
  id: STEP_ID.START,
  title: 'Start',
  isHidden: true
};

/** @type {import("utils/types").StepperStep[]} */
export const ADVANCED_STEPS = [
  { id: STEP_ID.ACCEPTANCE, title: 'Acceptance' },
  { id: STEP_ID.RETURN_WINDOW, title: 'Return Window' },
  { id: STEP_ID.EXCHANGES, title: 'Exchanges' },
  { id: STEP_ID.SHIPPING, title: 'Shipping' },
  { id: STEP_ID.FEES, title: 'Fees' },
  { id: STEP_ID.COMPLETED, title: 'Completed', isHidden: true }
];

/** @type {import("utils/types").StepperStep[]} */
export const BASIC_STEPS = [
  { id: STEP_ID.ACCEPTANCE, title: 'Acceptance' },
  { id: STEP_ID.RETURN_WINDOW, title: 'Return Window' },
  { id: STEP_ID.COMPLETED, title: 'Completed', isHidden: true }
];

/** @type {Record<keyof typeof STEP_ID, (keyof typeof import("../stubs").DEFAULT_TODOS)[]>} */
export const ADVANCED_STEPS_FEATURE_MAP = {
  [STEP_ID.START]: ['START'],
  [STEP_ID.ACCEPTANCE]: ['RETURN_REASONS', 'REFUND_METHODS'],
  [STEP_ID.RETURN_WINDOW]: ['RETURN_WINDOW'],
  [STEP_ID.EXCHANGES]: ['EXCHANGES'],
  [STEP_ID.SHIPPING]: ['SHIPPING'],
  [STEP_ID.FEES]: ['FEES'],
  [STEP_ID.COMPLETED]: ['COMPLETED']
};

/** @type {Record<keyof typeof STEP_ID, (keyof typeof import("../stubs").DEFAULT_TODOS)[]>} */
export const BASIC_STEPS_FEATURE_MAP = {
  [STEP_ID.START]: ['START'],
  [STEP_ID.ACCEPTANCE]: ['RETURN_REASONS'],
  [STEP_ID.RETURN_WINDOW]: ['RETURN_WINDOW'],
  [STEP_ID.COMPLETED]: ['COMPLETED']
};
